// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Organism_Teaser_Css from "./Organism_Teaser_Css.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Css_Identifier from "./Organism_Teaser_Css_Identifier.bs.js";

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("M", "L", undefined));

var display = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");

function Organism_Teaser_Focus(Props) {
  var background = Props.background;
  var buttonRef = Props.buttonRef;
  var label = Props.label;
  var onClick = Props.onClick;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var screenReadersLabel$1 = screenReadersLabel !== undefined ? "" + label + " " + screenReadersLabel + "" : label;
  if (style) {
    return React.createElement(Atom_Column.make, {
                background: background,
                children: React.createElement(Atom_Box.make, {
                      children: React.createElement(Atom_Cta.Button.make, {
                            ctaRef: buttonRef,
                            identifier: Organism_Teaser_Css_Identifier.moreOptionsButton,
                            label: label,
                            onClick: onClick,
                            screenReadersLabel: screenReadersLabel$1,
                            style: /* TeaserMoreOptions */29
                          }),
                      spacer: blockSpace
                    }),
                display: display,
                identifier: Organism_Teaser_Css_Identifier.panelFocus,
                rules: Organism_Teaser_Css.panelFocusRules,
                width: Particle_Screen_Constants.oneHundredPctWidth
              });
  } else {
    return null;
  }
}

var make = Organism_Teaser_Focus;

export {
  blockSpace ,
  display ,
  make ,
}
/* blockSpace Not a pure module */
